<template>
    <div class="root_page_center wrapper_setting">
        <div class="starHeaderQr">
            <ul>
                <li v-for="n in 9" :key="n">
                    <img src="../assets/images/sao.png" alt="" @click="showAlert(n)">
                </li>
            </ul>
        </div>
        <div class="frm_setting frm_settingQr">
            <form action="" method="post" id="frm_st" @submit="sendBusiness($event)">
                <h2 class="titleFrm_setting">Thông tin doanh nghiệp</h2>
                <div class="input_setting">
                    <label>Tên công ty</label>
                    <textarea v-model="company_name" rows="2" placeholder="Tên công ty" disabled></textarea>
                </div>
                <div class="input_setting">
                    <label>Mã số thuế</label>
                    <input type="text" v-model="taxCode" placeholder="Mã số thuế" disabled>
                </div>
                <div class="input_setting">
                    <label>Người đại diện</label>
                    <input type="text" v-model="staff" placeholder="Người đại diện" disabled>
                </div>
                <div class="input_setting">
                    <label>Địa chỉ trụ sở</label>
                    <textarea v-model="address" rows="2" placeholder="Địa chỉ trụ sở" disabled></textarea>
                </div>
                <div class="input_setting">
                    <label>Số điện thoại</label>
                    <input type="text" v-model="phone" placeholder="Số điện thoại" disabled>
                </div>
                <div class="input_setting">
                    <label>Vốn điều lệ</label>
                    <input type="text" v-model="showMoney" @input="onNumberInput" ref="input_amount" placeholder="Vốn điều lệ" disabled>
                </div>
                <div class="input_setting">
                    <label>Ngày thành lập</label>
                    <Datepicker v-model="date" select-text="Chọn" cancel-text="Hủy" :format-locale="vi" :format="format" :enable-time-picker="false" placeholder="Ngày thành lập" disabled/>
                </div>
                <div class="input_setting">
                    <label>Ngành nghề chính</label>
                    <input type="text" v-model="job" placeholder="Ngành nghề chính" disabled>
                </div>
                <div class="input_setting input_settingVselect">
                    <label>Tên ngân hàng</label>
                    <v-select
                        v-model="bankname"
                        :options="listBank"
                        label="name"
                        :reduce="bank => bank.id"
                        placeholder="Chọn ngân hàng" disabled
                    >
                        <template #option="{ name, image }">
                            <img :src="linkWebAdmin + image" style="height: 20px; margin-right: 8px;width: 60px;object-fit: contain;" />
                            {{ name }}
                        </template>
                        <template #selected-option="{ name, image }">
                            <img :src="linkWebAdmin + image" style="height: 20px; margin-right: 8px;width: 60px;object-fit: contain;" />
                            {{ name }}
                        </template>
                    </v-select>
                </div>
                <div class="input_setting">
                    <!--  @click="showAlert(10)" -->
                    <label>Số tài khoản</label>
                    <input type="text" v-model="banknumber" placeholder="Số tài khoản" disabled>
                </div>
                <div class="input_setting">
                    <label>Loại hình doanh nghiệp</label>
                    <select v-model="companyType" disabled>
                        <option value="" selected="selected">Loại hình doanh nghiệp</option>
                        <option :value="item.id" v-for="(item, index) in listCompany" :key="index">{{ item.name }}
                        </option>
                    </select>
                </div>
                <div class="input_setting">
                    <label>Cán bộ quản lý</label>
                    <input type="text" v-model="management" placeholder="Cán bộ quản lý">
                </div>
                <div class="input_setting">
                    <label>Email</label>
                    <input type="email" v-model="email" placeholder="Email">
                </div>
                <h3 class="titleFrm_setting titleFrm_settings">Thông tin chủ doanh nghiệp</h3>
                <div class="input_setting">
                    <label>Họ và tên</label>
                    <input type="text" v-model="fullname" placeholder="Họ và tên" disabled>
                </div>
                <div class="input_setting">
                    <label>Ngày tháng năm sinh</label>
                    <Datepicker v-model="birthday" select-text="Chọn" cancel-text="Hủy" :format-locale="vi" :format="format" :enable-time-picker="false" placeholder="Ngày, tháng, năm sinh" disabled/>
                </div>
                <div class="input_setting">
                    <label>Số CMND / CCCD</label>
                    <input type="text" v-model="identity_number" placeholder="Số CMND / CCCD" disabled>
                </div>
                <div class="input_setting">
                    <label>Giới tính</label>
                    <select v-model="sex" disabled>
                        <option value="" selected>Giới tính</option>
                        <option value="Nam">Nam</option>
                        <option value="Nữ">Nữ</option>
                    </select>
                </div>
                <div class="input_setting">
                    <label>Quốc tịch</label>
                    <input type="text" v-model="nationality" placeholder="Quốc tịch" disabled>
                </div>
                <div class="input_setting">
                    <label>Nơi thường trú</label>
                    <input type="text" v-model="residence" placeholder="Nơi thường trú" disabled>
                </div>
                <div class="input_setting">
                    <label>Ngày cấp</label>
                    <Datepicker v-model="dateIssue" select-text="Chọn" cancel-text="Hủy" :format-locale="vi" :format="format" :enable-time-picker="false" placeholder="Ngày cấp" disabled/>
                </div>
                <div class="input_setting">
                    <label>Nơi cấp</label>
                    <textarea v-model="placeIssue" rows="2" placeholder="Nơi cấp" disabled></textarea>
                </div>
                <div class="btn_setting">
                    <button type="submit">Gửi hồ sơ</button>
                </div>
            </form>
        </div>
        <div class="modalRedirect modal_register_success" v-if="showmodals">
            <div class="content_modalredirect content_modalredirectHds">
                <p @click="showmodals = false" class="closeMdredirect"><img src="../assets/images/close.png" @click="showmodals = false" alt=""></p>
                <div class="wrp_modal_type">
                    <h6 v-html="contentNoty"></h6>
                    <div class="btnxn_modal">
                        <router-link to="/loading">Tiếp tục kê khai</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="modalRedirect" v-if="showmodal">
            <div class="content_modalredirect">
                <p @click="showmodal = false" class="closeMdredirect">
                    <img src="../assets/images/close.png" @click="showmodal = false" alt="">
                </p>
                <h3 class="titleMd_qr">{{ contentDialog }}</h3>
                <router-link to="/loading">
                    <button type="button">Tiếp tục kê khai</button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'
import viCustom from '@/locales/vi-custom'
export default {
    name: 'QR_tool',
    data() {
        return {
            vi: viCustom,
            token: window.localStorage.getItem('token'),
            company_name: '',
            taxCode: '',
            staff: '',
            address: '',
            phone: '',
            money: '',
            showMoney: '',
            date: '',
            job: '',
            management: '',
            email: '',
            bankname: null,
            banknumber: '',
            companyType: '',
            fullname: '',
            birthday: '',
            identity_number: '',
            sex: '',
            nationality: '',
            residence: '',
            dateIssue: '',
            placeIssue: '',

            listCompany: [],
            format: 'dd/MM/yyyy',
            listBank: [],
            showmodal: false,
            showmodals: false,
            contentDialog: '',
            listNoty: [],
            contentNoty: [],
            numberIdNoty: 11
        }
    },
    components: {
        Datepicker,
        vSelect
    },
    mounted() {

    },
    created() {
        this.getCompany()
        this.getDataListInfo()
        this.getDataListInfoSetting()
        this.getListBank()
    },
    computed: {

    },
    beforeUnmount() {

    },
    methods: {
        getListBank() {
            this.axios.get(this.api_logoBanks).then((response) => {
                this.listBank = response.data.data
            })
        },
        getCompany() {
            this.axios.get(this.api_getCompany).then((response) => {
                this.listCompany = response.data.data
            })
        },
        getDataListInfo() {
            this.axios.get(this.api_userInfo,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.fullname = response.data.data.name
                this.phone = response.data.data.phone
                // this.bankname = Number(response.data.data.bank_id)
                this.bankname = response.data.data.bank_id == 0 ? null : Number(response.data.data.bank_id);
                this.companyType = Number(response.data.data.company_type)
                this.taxCode = response.data.data.tax_code
                this.birthday = new Date(response.data.data.dob)
                this.identity_number = response.data.data.identity_number
                this.sex = response.data.data.gender
                this.nationality = response.data.data.nationality
                this.residence = response.data.data.permanent_address
                    this.email = response.data.data.email
                if (response.data.data.issue_date == null) {
                    this.dateIssue = ''
                } else {
                    this.dateIssue = new Date(response.data.data.issue_date)
                }
                this.placeIssue = response.data.data.issue_place
            }).catch(e => {
                if (e.response.status == 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        getDataListInfoSetting() {
            this.axios.get(this.api_getBusiness,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                if (response.data.data != null) {
                    this.company_name = response.data.data.company_name
                    this.staff = response.data.data.representative_name
                    this.address = response.data.data.head_office_address
                    this.phone = response.data.data.phone_number
                    this.money = response.data.data.charter_capital
                    this.showMoney = this.formatNumber(String(this.money))
                    this.date = new Date(response.data.data.establishment_date)
                    this.job = response.data.data.main_business_line
                    this.management = response.data.data.staff_name
                    this.banknumber = response.data.data.bank_account_number
                }
            })
        },
        sendBusiness(e) {
            e.preventDefault()
            $('#loadingImg').show().fadeIn(10)
            // api_dialogAll
            this.axios.get(this.api_getDialog,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                $('#loadingImg').css('display', 'none')
                this.listNoty = response.data.data
                this.contentNoty = this.listNoty.content
                // this.contentNoty = this.listNoty[this.numberIdNoty - 1].content
                if(this.contentNoty != null){
                    this.showmodals = true
                }
            })
        },
        showAlert (index) {
            this.numberIdNoty = index
        },
        formatDate(date) {
            if (!date) return ''
            const yyyy = date.getFullYear()
            const dd = String(date.getDate()).padStart(2, '0')
            const mm = String(date.getMonth() + 1).padStart(2, '0')
            return `${yyyy}-${mm}-${dd}`
        },
        formatNumber(value) {
            const cleaned = value.split('.')[0];
            const num = cleaned.replace(/\D/g, '');
            return num.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },
        onNumberInput(e) {
            // const raw = e.target.value.replace(/,/g, '');
            const raw = e.target.value.replace(/\./g, '');
            this.money = raw
            this.showMoney = this.formatNumber(raw);
        },
    }
}
</script>